import DocumentMeta from 'react-document-meta';
import React, {Component} from 'react';

export default class About extends Component {
  render() {
    const meta = {
      title: 'About | PersonaGenerator',
      description: 'PersonaGenerator is an internal tool that we use with clients at Mobility Labs to create personas.',
      auto: {
        ograph: true
      }
    };
    return (
      <div className="about container">
        <DocumentMeta {...meta} />
        <h2>What is this?</h2>
        <p>Persona<strong>Generator</strong> is an internal tool that we use with clients at&nbsp;
        <a href="http://mobility-labs.com">Mobility Labs</a>. We wanted to create a simple app to make the process
        easier for us and our clients. To that end we built it as part of a week long hackathon in January 2016.</p>
        <h2>How do I use it?</h2>
        <p>Persona<strong>Generator</strong> is a tool to help you create personas to align your work to the visitors,
        users, customers or clients (however you refer to them). Personas are meant to be specific representations of
        this key group. The info you include in a persona should be actionable but not include identifying information
        because its just a representation. To learn more you can read&nbsp;
        <a target="_blank" rel="noopener noreferrer" href="https://en.wikipedia.org/wiki/Persona_(user_experience)">this</a> article on Wikipedia
        about personas.</p>
        <p>Once you have a persona the way you like it, you can share it using the links in the right sidebar. No need
        to create an account as long as you save those links. If you think you might lose them, have us email you a
        copy of them.</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./client/pages/About.jsx